export default __webpack_public_path__ + "static/media/cardFlip.c11ca3fd.mp3";